export default __webpack_public_path__ + "img/9501512722fd9ba71e8f3d20b26889af.png";